export default __webpack_public_path__ + "static/media/sync1.8d66c82a.png";